//
// Extends our custom HTML Video component
// - npm install @vimeo/player
//

import Video from './Video';
import Player from '@vimeo/player';


export default class VimeoVideoPlayer extends Video {
	constructor(element, options) {
		super(element, options)

		this.vimeoOptions =
		{
			// this disables the native vimeo controls, not ours
			controls: false,
			loop: this.options['loop'],
			autoplay: this.options['autoplay'],
			byline: false,
			background: true,
			url: element.dataset.video
		}

		this.video = new Player(element.querySelector('.video__wrapper'), this.vimeoOptions);

		for (let option in this.options) {
			let bool = this.options[option];
			switch (option) {
			case 'autoplay':
				this.video.autoplay = bool;
				bool ? this.play() : this.pause();
				break;
			case 'loop':
				this.video.loop = bool;
				break;
			case 'muted':
				this.video.muted = this.options[option]
				bool ? this.mute() : this.setVolume(1)
				break;
			case 'controls':
				bool ? '' : this.hideControls()
				break;
			case 'progress':
				if (bool) {
					this.video.on('timeupdate', (e) => this.updateTimeElapsed(e.duration, e.seconds));

					this.getSeek(this.video.totalDuration, this.video.currentTime)
				} else {
					this.hideProgress()
				}
			}
		}
	}
	play() {
		super.play()
		this.video.play();
	}
	mute() {
		super.mute();
		this.video.setVolume(0)
	}
	restart() {
		super.restart();
		this.video.setCurrentTime(this.totalDuration * 0.005)
	}
	pause() {
		super.pause()
		this.video.pause()
	}
	setVolume(amount) {
		super.setVolume(amount)
		this.video.muted = false;
		this.video.setVolume(amount)
	}
	setTime(percentage) {
		super.setTime(percentage);
		let seconds = Math.max((percentage / 100) * this.totalDuration, 0)
		this.video.setCurrentTime(seconds);
	}
}